/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Modal } from 'components';
import Theme from './theme';

const PricingTable = props => {

    const { history } = props;

    const [modalActive, showModal] = useState(false);

    return (

        <Theme>

            { <Modal
            title="Featured Job Ads"
            content="Featured job ads have more visibility than normal job ads. They will appear on top of the page(s).
            Therefore users will see your featured job ad more than normal ads."
            modalActive={modalActive}
            showModal={showModal}
            /> }

            <div className="columns" >

                <div className="column" >

                    <div className="box">
    
                        <h4><b><i className="far fa-star icon" ></i> STARTER</b></h4>

                        <p>Publish 1 Job Ad</p>

                        <br />

                        <div className="bottomSection" >

                            <h4 className="subtitle is-4" >€50</h4>

                            <button onClick={()=>history.push('/payment?product=standard')} className="button is-info is-fullwidth submit">Purchase</button>
                        
                        </div>

                    </div>

                </div>

                <div className="column" >

                    <div className="box">
    
                        <h4><b><i className="fas fa-star-half-alt icon" ></i> PROFESSIONAL</b></h4>

                        <p>Publish 5 Job Ads</p>

                        <br />

                        <div className="bottomSection" >

                            <h4 className="subtitle is-4" >€200</h4>

                            <button onClick={()=>history.push('/payment?product=professional')} className="button is-info is-fullwidth submit">Purchase</button>

                        </div>

                    </div>

                </div>

                <div className="column" >

                    <div className="box">
    
                        <h4><b><i className="fas fa-star icon" ></i> ENTERPRISE</b></h4>

                        <p>Publish 5 <a onClick={()=>showModal(true)} >featured</a> Job Ads</p>

                        <br />

                        <div className="bottomSection" >

                            <h4 className="subtitle is-4" >€300</h4>

                            <button onClick={()=>history.push('/payment?product=enterprise')} className="button is-info is-fullwidth submit">Purchase</button>

                        </div>

                    </div>
                    
                </div>

            </div>

        </Theme>

    );

}

export default withRouter(PricingTable);
